export const choreViewTranslateEs = {
    DETAILS_CHORES:{
        AMOUNT_LABEL: "Monto de recompensa",
        PROOF_LABEL: "Prueba de imagen",
        DESCRIPTION_LABEL: "Descripcion de misión",
        DEADLINE_LABEL: "Fecha limite",
        APPROVED_BUTTON : "Aprobar y enviar recompensa",
        REJECTED_BUTTON : "Rechazar",
        PAY_REWARD_BUTTON : "Pagar recompensa"
    },
    REJECT:{
        TOAST:{
          DETAIL_PART_1: "La misión ha sido recahzada, informaremos a",
          DETAIL_PART_2: "que no la aprobaste"
        }
      }
}